/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable indent */
import { AfterViewInit, Component, Input, NgModule } from '@angular/core';
import { Modal, ModalOptions } from 'flowbite';
import { SystemButtonModule } from '../../atoms/button/button.directive';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-system-new-modal',
  templateUrl: './new-modal.component.html',
})
export class NewModalComponent implements AfterViewInit {
  @Input({
    required: true,
  })
  identificator!: string;

  @Input({
    required: true,
  })
  title!: string;

  @Input({
    required: true,
  })
  buttonName!: string;
  @Input({
    required: true,
  })
  action!: () => Promise<void> | void;
  @Input({})
  disabledButton!: boolean;
  @Input({
    required: true,
  })
  closeModal!: () => Promise<void> | void;
  modal!: Modal;
  options: ModalOptions = {
    placement: 'bottom-right',
    backdrop: 'dynamic',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
    closable: true,
  };

  constructor() {}

  ngAfterViewInit() {
    const $targetElement = document.getElementById(this.identificator);
    this.modal = new Modal($targetElement, this.options);
  }

  open() {
    this.modal.show();
  }

  async close() {
    await this.closeModal();
    this.modal.hide();
  }

  async onClickAction() {
    await this.action();
    this.modal.hide();
  }
}

@NgModule({
  declarations: [NewModalComponent],
  exports: [NewModalComponent],
  imports: [SystemButtonModule, CommonModule],
})
export class SystemNewModalModule {}
